export const resolveOwnedState = (backendOwned: boolean, override: boolean | null): boolean => {
  return override ?? backendOwned;
};

export const shouldClearOwnedOverride = (backendOwned: boolean, override: boolean | null): boolean => {
  return override !== null && backendOwned === override;
};

/**
 * A lecture is withheld only when the server says the viewer is not enrolled
 * AND the course is not open access. course-server marks published courses
 * openAccess and serves their lectures to anyone, so the client must not
 * block what the server hands out.
 */
export const lacksCourseAccess = (
  summary?: { owned?: boolean | null; openAccess?: boolean | null } | null,
): boolean => summary?.owned === false && summary?.openAccess !== true;
